import { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "./BreadCrumbs";
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Checkbox,
  TextField,
  Typography,
  useMediaQuery,
  Tooltip,
  IconButton,
} from "@mui/material";
import moment from "moment";
import {
  CmpDatePickerField001V1,
  CmpTextFieldEnterV1,
} from "../../Component/Common/ToolBox/ToolBoxV1";
import "./VendorDiscontinueChangeRequest.css";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import FilterModal from "./FilterModal";
import {
  ISTCR_Reason_Getrow,
  VNDRDISA_Reverse,
  VNDRDISA_VNDRDISB_Delete,
  VNDRDISA_VNDRDISB_Update,
  VNDRDISB_Barcode_List_Getrow,
  VNDRDISB_Getrow,
  VNDRDISB_Items_Discontinue_Status_Getrow,
} from "../../Server/ApiV2";
import {
  VendorDiscontinueChangeRequestRo,
  vRdxUserInfo,
} from "../../Redux/roStore";
import { Head_Set } from "./SliceVendorDiscontinueChangeRequest";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import { DataGridPro, gridRowIdsSelector, useGridApiRef } from "@mui/x-data-grid-pro";
import DeleteIcon from "@mui/icons-material/Delete";
import { confirmAlert } from "react-confirm-alert";
import GCToggleSearchV1 from "../../Component/Common/ReuseableComponent/GCToggleSearchV1";
import { fExecuteAPI } from "../../Server/Apis";
import GCAutocompleteCheckboxFixSizeUid from "./GCAutocompleteCheckboxFixSizeUid";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

const VendorDiscontinueChangeRequestDetail = () => {
  const dispatch = useDispatch();
  const barcodeRef = useRef();
  const apiRef = useGridApiRef();

  const vMediaQuery = useMediaQuery("(max-width:600px)");
  const transObj = useSelector(
    (state) => state.SliceVendorDiscontinueChangeRequest.value.Head
  );
  //Location
  const vRdxuserLoc = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const lpoGroupDropDown = useSelector(
    (state) => state.SliceDB.value.LPO_GROUP
  );

  // const [Location, setLocation] = useState([]);
  const [reasonAttributes, setReasonAttributes] = useState({});

  const initialBufferObj = {
    B_Srno: 0,
    B_Itemcd: "",
    ItemName: "",
    B_Barcode: "",
    Old_DisContinued: "N",
    New_DisContinued: "N",
    B_LocationCSV: vRdxuserLoc?.map((item) => item.Uid),
    P_B_Narration: "",
    P_B_RejectDetail: "",
    P_B_RejectNarration: "",
  };
  const [open, setOpen] = useState(false);
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [DetailData, setDetailData] = useState([]);
  const [bufferObject, setBufferObj] = useState(initialBufferObj);
  const [barcode, setBarcode] = useState([]);


  // useEffect(() => {
  //   if (vRdxuserLoc.length) {
  //     // wait until we really have the data
  //     setLocation(vRdxuserLoc);

  //     // pre-select every location
  //     setBufferObj((prev) => ({
  //       ...prev,
  //       B_LocationCSV: vRdxuserLoc.map((l) => l.Uid),
  //     }));

  //     fLoadDetail(); // keep if you still need the call here
  //   }
  // }, [vRdxuserLoc]);

  const fLoadDetail = async (transid = "", isNewBtnClick = false) => {
    const obj = {
      B_Transid: isNewBtnClick ? "" : transObj?.A_Transid || transid,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const detailRes = await VNDRDISB_Getrow(FinalObj);
    if (detailRes?.status === 200) {
      setDetailData(detailRes?.data?.ResultSet);
    }
  };

  // Item Code Item Name

  const loadBarcodeList = async (ItmCd) => {
    if (ItmCd === "") {
      fAlertToast("FAILED", "Item Code should not be empty");
      return;
    }

    const obj = {
      ItmCd: ItmCd,
    };

    const response = await VNDRDISB_Barcode_List_Getrow(obj);

    if (response?.status === 200) {
      if (response?.data?.ResultSet.length > 0) {
        setBarcode(response?.data?.ResultSet);
      }
      return response?.data?.ResultSet;
    } else {
      return [];
    }
  };
  const getReasonAttribute = async () => {
    try {
      const res = await ISTCR_Reason_Getrow();
      if (res?.status === 200) {
        setReasonAttributes(res?.data?.ResultSet || {});
        console.log(res?.data?.ResultSet);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDetailChange = (field, value, event = null) => {
    setBufferObj((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleItemSelection = async (ItmCd, Name1) => {
    setBufferObj((prev) => ({
      ...prev,
      B_Itemcd: ItmCd,
      ItemName: Name1,
    }));
    const resp = await loadBarcodeList(ItmCd);
    setBufferObj((prev) => ({
      ...prev,
      B_Barcode: resp.length > 0 ? resp[0]?.Cd : "",
    }));
    await fLoadItemDetail(resp.length > 0 ? resp[0]?.Cd : "", ItmCd || "");
  };

  const handleChange = (field, value, type = "text") => {
    setBufferObj((prev) => {
      let parsedValue;

      if (type === "checkbox") {
        parsedValue = value;
      } else {
        const parsed = parseInt(value);
        parsedValue = isNaN(parsed) ? 0 : parsed;
      }

      const updated = {
        ...prev,
        [field]: parsedValue,
      };

      return updated;
    });
  };

  const handleRowClick = async (selectedRow) => {
    setBufferObj((prevV) => ({
      ...prevV,
      B_Srno: selectedRow.B_Srno,
      B_Itemcd: selectedRow.B_Itemcd,
      ItemName: selectedRow.ItemName,
      B_Barcode: "",
      Old_DisContinued: "N",
      New_DisContinued: "N",
      B_LocationCSV: selectedRow.B_LocationCSV,
      P_B_Narration: selectedRow.P_B_Narration,
      P_B_RejectDetail: selectedRow.P_B_RejectDetail,
      P_B_RejectNarration: selectedRow.P_B_RejectNarration,
    }));
    // setBufferObj((prevV) => ({
    //   ...prevV,
    //   ...selectedRow,
    // }));
    await loadBarcodeList(selectedRow.B_Itemcd);

    setBufferObj((prevV) => ({
      ...prevV,
      B_Barcode: selectedRow.B_Barcode,
      Old_DisContinued: selectedRow.Old_DisContinued,
      New_DisContinued: selectedRow.New_DisContinued,
    }));
  };

  const fValidationHead = () => {
    const HeadObject = VendorDiscontinueChangeRequestRo();
    let isValid = true;
    if (HeadObject?.Head?.A_Transid === "") {
      fAlertToast("FAILED", "Trans Id should not be empty");
      return;
    }
    if (HeadObject?.Head?.A_Date === "") {
      fAlertToast("FAILED", "Date should not be empty");
      isValid = false;
      return;
    }
    if (HeadObject?.Head?.A_Location === "") {
      fAlertToast("FAILED", "Location should not be empty");
      isValid = false;
      return;
    }
    if (HeadObject?.Head?.VendorName === "") {
      fAlertToast("FAILED", "Vendor should not be empty");
      isValid = false;
      return;
    }
    if (HeadObject?.Head?.VendorCd === "") {
      fAlertToast("FAILED", "Vendor should not be empty");
      isValid = false;
      return;
    }

    if (HeadObject?.Head?.LPOGruppen === "") {
      fAlertToast("FAILED", "LPOGruppen should not be empty");
      isValid = false;
      return;
    }

    return isValid;
  };

  const fValidationDetail = () => {
    let isValid = true;

    if (
      bufferObject.B_Itemcd === "" ||
      bufferObject.B_Itemcd == undefined ||
      bufferObject.B_Itemcd === null
    ) {
      fAlertToast("FAILED", "Item Code is required.");
      isValid = false;
      return;
    }

    if (
      bufferObject.Old_DisContinued === "" ||
      bufferObject.Old_DisContinued === undefined ||
      bufferObject.Old_DisContinued === null
    ) {
      fAlertToast("FAILED", `Old_DisContinued is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.New_DisContinued === "" ||
      bufferObject.New_DisContinued === undefined ||
      bufferObject.New_DisContinued === null
    ) {
      fAlertToast("FAILED", `New_DisContinued is required `);
      isValid = false;
      return;
    }

    return isValid;
  };

  const boolToYN = (val) => (val ? "Y" : "N");
  const normalizeBool = (val) =>
    typeof val === "boolean" ? boolToYN(val) : val;

  const { UserID } = vRdxUserInfo() || {};

  const fSave = async (isApproved, name) => {
    const Head = VendorDiscontinueChangeRequestRo()?.Head;
    if (!fValidationHead()) return;
      if (
    !bufferObject?.P_B_Narration
  ) {
    fAlertToast("FAILED", " Vendor Discontinue Reason is mandatory");
    return;
  }
    let items;
    if (!isApproved) {
      if (!fValidationDetail()) return;
      items = [bufferObject];
    } else {
      if (DetailData?.length === 0) {
        fAlertToast("FAILED", "Save at least one line item");
        return;
      }

      items = DetailData;
    }

    const requestPayload = {
      A_TransId: Head?.A_Transid || 0,
      A_Date: moment(Head?.A_Date).format("MM/DD/YYYY"),
      A_Loc: Head?.A_Location,
      A_Narration: Head?.A_Narration,
      A_UserCd: UserID,
      A_Vendor: Head?.VendorCd,
      DeleteInsert: "N",
      Items: items,
      isApproved,
      A_LocationCSV: Head?.A_Locationcsv,
      A_LOPGruppen: Head?.LPOGruppen,
    };

    const StockResponse = await VNDRDISA_VNDRDISB_Update(requestPayload);

    if (StockResponse?.status === 200) {
      fAlertToast("SUCCESS", `${name} Successfully`);
      dispatch(
        Head_Set({
          ...transObj,
          A_Transid: StockResponse.data?.ResultSet?.[0]?.A_Transid,
          A_Status: name === "Approved" ? "POST" : transObj.A_Status,
          A_Confirm_Status:
            name === "Approved" ? "ENTER" : transObj.A_Confirm_Status,
        })
      );
      fNewDetail(StockResponse.data?.ResultSet?.[0]?.A_Transid);
    }
  };

  const handleDelete = async (row) => {
    var obj = {
      B_Transid: row?.B_Transid,
      B_Itemcd: row?.B_Itemcd,
      B_Barcode: row?.B_Barcode,
    };

    const transDelete = await VNDRDISA_VNDRDISB_Delete(obj);
    if (transDelete?.status === 200) {
      fAlertToast("SUCCESS", "Deleted Successfully");
      fNewDetail(row?.B_Transid);
    }
  };

  const fNewHead = () => {
    dispatch(
      Head_Set({
        A_Transid: 0,
        A_Date: new Date(),
        A_Location: vRdxuserLoc?.length > 0 ? vRdxuserLoc[0]?.Uid : "",
        Loc_Name: "",
        A_Narration: "",
        A_Status: "ENTER",
        A_Confirm_Status: "ENTER",
        CreatedBy: "",
        CreatedDate: "",
        VendorName: "",
        VendorCd: "",
        A_Locationcsv: "",
      })
    );
    fNewDetail("", true);
    setTimeout(() => {
      document.getElementsByName("A_Narration")[0].focus();
    }, 500);
  };

  const fNewDetail = async (id = "", isNewBtnClick = false) => {
    setBufferObj(initialBufferObj);
    setBarcode([]);
    await fLoadDetail(id, isNewBtnClick);
    setTimeout(() => {
      document?.getElementsByName("ItemName")[0]?.focus();
    }, 500);
  };

  const columnGroupingModel = [
    {
      groupId: "Discontinued",
      children: [
        { field: "Old_DisContinued" },
        { field: "New_DisContinued" },
        { field: "P_B_Narration" },
      ],
    },
  ];

  const HeadObject = VendorDiscontinueChangeRequestRo();

  const fLoadItemDetail = async (barcd, ItmCd) => {
    try {
      const obj = {
        Barcode: !!barcd ? barcd : bufferObject?.B_Barcode,
        Vendor: HeadObject?.Head?.VendorCd,
        ItmCd: ItmCd ? ItmCd : bufferObject?.B_Itemcd,
        Loc: transObj?.A_Location,
      };
      const response = await VNDRDISB_Items_Discontinue_Status_Getrow(obj);
      if (response?.status === 200) {
        if (response?.data?.ResultSet.length > 0) {
          setBufferObj((prevV) => ({
            ...prevV,
            Old_DisContinued: response?.data?.ResultSet[0]?.DisContinued,
            New_DisContinued: response?.data?.ResultSet[0]?.DisContinued,
          }));
        } else {
          setBufferObj((prevV) => ({
            ...prevV,
            Old_DisContinued: "N",
            New_DisContinued: "N",
          }));
        }
        return response?.data?.ResultSet;
      }
    } catch (error) {}
  };

  //vendor start
  const [
    sGC_Toggle_Head_Customer_GridData,
    setGC_Toggle_Head_Customer_GridData,
  ] = useState([]);
  const [
    sGC_Toggle_Head_Customer_ToggleDropDowm,
    setGC_Toggle_Head_Customer_ToggleDropDowm,
  ] = useState(false);

  const [
    sGC_Toggle_Head_Customer_SearchDropdownObj,
    setGC_Toggle_Head_Customer_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });

  //2nd call
  const fGC_Toggle_Head_Customer_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
        ...obj,
        Data: transObj.VendorName,
      }));
      if (transObj.VendorName != "") {
        const vExactSearch = await Get_ToggleDropDown_Load(
          transObj.VendorName,
          "Any",
          "C",
          "N",
          transObj.A_Location
        );
        if (vExactSearch.length > 0) {
          setGC_Toggle_Head_Customer_GridData(vExactSearch);
        } else {
          setGC_Toggle_Head_Customer_GridData([]);
        }
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGC_Toggle_Head_Customer_Toggle();
    }
  };

  const xfGC_Toggle_Head_Customer_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_Customer_ToggleDropDowm) {
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);

      setGC_Toggle_Head_Customer_GridData([]);
      setGC_Toggle_Head_Customer_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGC_Toggle_Head_Customer_ToggleDropDowm(true);
    }
  }, [sGC_Toggle_Head_Customer_ToggleDropDowm]);

  const fOnKeyUpVendor = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        transObj.VendorName,
        "Any",
        "C",
        "Y",
        transObj.A_Location
      );
      if (vExactSearch.length > 0) {
        dispatch(
          Head_Set({
            ...transObj,
            VendorCd: vExactSearch[0]?.AcCd,
            VendorName: vExactSearch[0]?.Name1,
          })
        );
      } else {
        fGC_Toggle_Head_Customer_Dropdown_SearchModalKey(e);
      }
    }
    if (e.key === "Backspace" && transObj.VendorCd) {
      dispatch(
        Head_Set({
          ...transObj,
          VendorCd: "",
          VendorName: "",
        })
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        sGC_Toggle_Head_Customer_SearchDropdownObj.Data,
        sGC_Toggle_Head_Customer_SearchDropdownObj.Type,
        "C",
        "N",
        dispatch
      );
      if (vExactSearch.length > 0) {
        setGC_Toggle_Head_Customer_GridData(vExactSearch);
      } else {
        setGC_Toggle_Head_Customer_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const Get_ToggleDropDown_Load = async (
    xData = transObj?.VendorName,
    xType = "Any",
    xAcTyp = "C",
    xExact = "Y",
    A_Loc = transObj.A_Location
  ) => {
    let vLoaded_Cost_FreightObj = {
      Data: xData,
      Type: xType,
      Loc: A_Loc,
      AcTyp: xAcTyp,
      Exact: xExact,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
    const vLandedCostDropdownSearch = await fExecuteAPI(
      "AccountTransSearch_GETROW",
      FinalObj
    );
    if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
      let GridID = [];
      if (vLandedCostDropdownSearch.ResultSet.length > 0) {
        let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        return GridID;
      } else {
        return GridID;
      }
    } else {
      fAlertToast("FAILED", "Error in loading LandedCost Api");
      return [];
    }
  };
  const fkeyup = useCallback((e) => {
    if (e.which == 27 || e.key === "Escape") {
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);
    }
  }, []);
  // press esc to close toggle
  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);
  //click anywhere to close the toggle
  useEffect(() => {
    const handleClick = (event) => {
      // For vendor toggle
      if (sGC_Toggle_Head_Customer_ToggleDropDowm) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setGC_Toggle_Head_Customer_ToggleDropDowm(false);
        }
      }

      // For item name toggle
      if (sItemToggleDropdown) {
        const itemToggleElement = event.target.closest(".toggleSearch");
        if (!itemToggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sGC_Toggle_Head_Customer_ToggleDropDowm, sItemToggleDropdown]);

  //vendor end
  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        bufferObject?.ItemName,
        transObj?.A_Location
      );
      if (vItemSearchFull.length > 0) {
        handleItemSelection(
          vItemSearchFull[0]?.ItmCd,
          vItemSearchFull[0]?.Name1
        );
        setItemToggleDropdown(false);
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace" && bufferObject?.B_Itemcd) {
      setBufferObj((prev) => ({
        ...prev,
        B_Itemcd: "",
        ItemName: "",
      }));
    }
  };
  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        transObj?.A_Location,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  const fGCToggleItemOnRowClick = async (e) => {
    handleItemSelection(e?.row?.ItmCd, e?.row?.Name1);
    setItemToggleDropdown(false);
  };

  const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
    let vSeatchVendor = {
      Data: xData,
      Type: xType,
      Loc: xA_Loc,
      v_isActiveOnly: false,
      v_Vendor: HeadObject?.Head?.VendorCd || "",
      v_isActiveOnly: false,
    };
    const vItemSearch = await fExecuteAPI(
      "SEARCHITEM001_GETROW",
      vSeatchVendor
    );
    if (vItemSearch?.Type?.toUpperCase() == "SUCCESS") {
      let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSearchGridData(vItemSearchArr);
    } else {
      fAlertToast(
        "FAILED",
        vItemSearch.response.data.message
          ? vItemSearch.response.data.message
          : "Error in SearchItem"
      );
    }
  };
  const GetItemFullSearchArr = async (xItemName, xLoc) => {
    let vItemFullSearchDataObj = {
      anyData: xItemName,
      transType: "F",
      report: "Y",
      loc: xLoc,
    };

    const vItemSearchFull = await fExecuteAPI(
      // "ITEM_SEARCHFULL_GETROW",
      "SEARCHEXACTITEM_GETROW",
      vItemFullSearchDataObj
    );
    //status code "" so Success is checked
    if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
      if (vItemSearchFull?.ResultSet?.length > 0) {
        return vItemSearchFull.ResultSet;
      } else {
        return [];
      }
    } else {
      fAlertToast(
        "FAILED",
        vItemSearchFull?.Type?.response?.data?.message
          ? vItemSearchFull?.Type?.response?.data?.message
          : "Error in vItemSearchFullArr"
      );
      return [];
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);

      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
    setGC_Toggle_Head_Customer_ToggleDropDowm(false);
  }, [sItemToggleDropdown]);

  const fItemToggleClick = () => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: bufferObject?.ItemName,
    }));

    if (bufferObject?.ItemName != "") {
      GetSearchItem(
        bufferObject?.ItemName,
        "Any",
        transObj?.A_Location,
        setGridSelectRowData
      );
    }

    handleClick();
  };

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const reverseSave = async () => {
    const isHeadValid = fValidationHead();
    if (!isHeadValid) return;
    const HeadObject = VendorDiscontinueChangeRequestRo();
    const obj = {
      A_TransId: HeadObject?.Head?.A_Transid || 0,
      UserCd: vRdxUserInfo()?.UserID,
    };
    const reverseRes = await VNDRDISA_Reverse(obj);
    if (reverseRes?.status === 200) {
      fAlertToast("SUCCESS", "Reversed Successfully");
      dispatch(
        Head_Set({
          ...transObj,
          A_Status: "ENTER",
          A_Status_CM: "ENTER",
        })
      );
    } else {
      fAlertToast("FAILED", "Reverse Failed");
    }
  };

   const handleExport = () => {
      apiRef.current.exportDataAsCsv({
      getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
      includeHeaders: true,
      utf8WithBom: true,
    });
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  useEffect(() => {
    getReasonAttribute();
    fLoadDetail();
  }, []);

  return (
    <>
      <Breadcrumbs />
      <Grid
        container
        spacing={{ xs: 0.5, sm: 1, md: 1.5 }}
        alignItems={"flex-end"}
        pt={1}
      >
        {/* Transaction Info */}
        <Grid item xs={4} sm={3} md={1.5}>
          <Typography>Trans ID</Typography>
          <CmpTextFieldEnterV1
            xSize="small"
            xName="Transation ID"
            xValue={transObj?.A_Transid}
            xReadOnly={true}
            xDisabled={true}
          />
        </Grid>
        <Grid item xs={8} sm={4} md={2}>
          <Typography>Trans Date</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName="A_Date"
            xValue={transObj?.A_Date}
            xOnChange={(newValue) =>
              dispatch(
                Head_Set({ ...transObj, A_Date: newValue?.$d ?? newValue })
              )
            }
          />
        </Grid>
        <Grid item xs={12} sm={5} md={2.5}>
          <Typography>Trans Location</Typography>
          <FormControl fullWidth>
            <Select
              size="small"
              value={transObj?.A_Location}
              name="A_Location"
              onChange={(e) =>
                dispatch(Head_Set({ ...transObj, A_Location: e.target.value }))
              }
            >
              {vRdxuserLoc?.map((loc) => (
                <MenuItem className="menuSm" key={loc.Uid} value={loc.Uid}>
                  {loc?.Name1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography>Vendor</Typography>
          <GCToggleSearchV1
            xLabelText=""
            xName="Vendor"
            xType="text"
            xValue={transObj.VendorName}
            xReadOnly={false}
            xOnChange={(e) => {
              dispatch(Head_Set({ ...transObj, VendorName: e.target.value }));
              setGC_Toggle_Head_Customer_ToggleDropDowm(false);
            }}
            xOnKeyUp={fOnKeyUpVendor}
            xonClickbtn={fOnKeyUpVendor}
            xrows={sGC_Toggle_Head_Customer_GridData}
            xcolumns={[
              { field: "id", headerName: "ID", width: 70, hide: true },
              { field: "AcCd", headerName: "Code", width: 100 },
              { field: "Name1", headerName: "Name", flex: 1 },
            ]}
            xRowClick={(e) => {
              dispatch(
                Head_Set({
                  ...transObj,
                  VendorCd: e?.row?.AcCd,
                  VendorName: e?.row?.Name1,
                })
              );
              xfGC_Toggle_Head_Customer_Toggle();
              setGC_Toggle_Head_Customer_ToggleDropDowm(false);
            }}
            xToggle={sGC_Toggle_Head_Customer_ToggleDropDowm}
            xData={["Any", "Code", "Name"]}
            xOnChangeDropdownInput={(e) => {
              setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
                ...obj,
                [e.target.name]: e.target.value,
              }));
            }}
            xDropdownObj={sGC_Toggle_Head_Customer_SearchDropdownObj}
            xOnKeyUpDropdownInput={
              fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load
            }
            xtabIndex="7"
          />
        </Grid>{" "}
        <Grid item xs={12} sm={6} md={3}>
          <Typography>Narration</Typography>
          <TextField
            size="small"
            value={transObj?.A_Narration}
            name="A_Narration"
            onChange={(e) =>
              dispatch(Head_Set({ ...transObj, A_Narration: e.target.value }))
            }
            fullWidth
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Typography>LPO Group</Typography>
          <FormControl fullWidth size="small">
            <Select
              displayEmpty
              value={transObj?.LPOGruppen}
              onChange={(e) =>
                dispatch(Head_Set({ ...transObj, LPOGruppen: e.target.value }))
              }
              renderValue={(selected) =>
                selected
                  ? lpoGroupDropDown?.find((x) => x.UId === selected)?.Name1
                  : "Select Reason"
              }
              disabled={HeadObject?.Head?.A_Status?.toUpperCase() !== "ENTER"}
            >
              {lpoGroupDropDown?.map((opt) => (
                <MenuItem className="menuSm" key={opt.UId} value={opt.UId}>
                  {opt.Name1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/* Item Info */}{" "}
        <Grid item xs={12} sm={6} md={3.5}>
          <Typography> Location</Typography>
          <GCAutocompleteCheckboxFixSizeUid
            xLabelText="Location"
            xValue={bufferObject?.B_LocationCSV}
            setValue={(updated) => {
              // handleDetailChange("A_Locationcsv", updated);
              handleDetailChange("B_LocationCSV", updated);
            }}
            options={vRdxuserLoc ?? []}
            objName="location"
            placeholder="Search Location"
          />
        </Grid>{" "}
        <Grid item xs={4.5} sm={3} md={2}>
          <Typography>Item Code</Typography>
          <TextField
            value={bufferObject?.B_Itemcd}
            onChange={(e) => handleDetailChange("B_Itemcd", e.target.value, e)}
            sx={{
              "& .MuiInputBase-root": {
                padding: 0, // Removes outer padding
              },
              "& .MuiInputBase-input": {
                padding: "8.5px 11px", // Removes inner input padding
              },
            }}
            fullWidth
            disabled
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={7.5} sm={5} md={3.5}>
          <Typography>Item Name</Typography>
          <GCToggleSearchV1
            xLabelText=""
            xtabIndex="101"
            xName="B_ItmName"
            xType="text"
            xValue={bufferObject?.ItemName}
            xReadOnly={false}
            xOnChange={(e) => {
              setBufferObj((prev) => ({
                ...prev,
                B_Itemcd: "",
                B_Barcode: "",
              }));
              setBarcode([]);
              handleDetailChange("ItemName", e.target.value);
            }}
            xOnKeyUp={fItemSearchKey}
            xonClickbtn={fItemSearchKey}
            xrows={sGridSelectRowData}
            xcolumns={[
              { field: "id", headerName: "ID", width: 70, hide: true },
              { field: "ItmCd", headerName: "Code", width: 90 },
              { field: "Name1", headerName: "Name", flex: 1 },
            ]}
            xRowClick={fGCToggleItemOnRowClick}
            xRowCellClick={fGCToggleItemOnCellKeyDown}
            xToggle={sItemToggleDropdown}
            xData={["Any", "Code", "Barcode", "Name", "RefNo", "NameFL"]}
            xOnChangeDropdownInput={fOnChangeItem}
            xDropdownObj={sItemSearchDropdownObj}
            xOnKeyUpDropdownInput={fOnKeyUpItem}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={2} lg={2.5}>
          <Typography>Barcode</Typography>
          <FormControl fullWidth>
            <Select
              size="small"
              value={bufferObject?.B_Barcode}
              name="B_Barcode"
              inputRef={barcodeRef}
              onChange={(e) => {
                setBufferObj((prevV) => ({
                  ...prevV,
                  B_Barcode: e.target.value,
                }));
                fLoadItemDetail(e.target.value);
              }}
            >
              {barcode.map((barcd) => (
                <MenuItem className="menuSm" key={barcd.Cd} value={barcd.Cd}>
                  {barcd?.BarcodeDetails}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>{" "}
        {/* Checkbox Controls */}
        <Grid
          item
          xs={12}
          sm={5}
          md={4}
          lg={3.7}
          display={"flex"}
          flexDirection={"column"}
        >
          <Box display="flex" gap={1}>
            <Box display="flex" alignItems="center" flexDirection={"row"}>
              <Typography variant="body2">Old Discountinue</Typography>
              <Checkbox
                sx={{
                  padding: "5px",
                }}
                checked={bufferObject.Old_DisContinued === "Y"}
                disabled
              />
            </Box>
            <Box display="flex" alignItems="center" flexDirection={"row"}>
              <Typography variant="body2">New Discountinue</Typography>
              <Checkbox
                sx={{
                  padding: "5px",
                }}
                checked={bufferObject.New_DisContinued === "Y"}
                onChange={(e) =>
                  handleChange(
                    "New_DisContinued",
                    e.target.checked ? "Y" : "N",
                    "checkbox"
                  )
                }
              />
            </Box>
          </Box>
          <FormControl size="small">
            <Select
              displayEmpty
              value={bufferObject.P_B_Narration || ""}
              onChange={(e) =>
                setBufferObj((prev) => ({
                  ...prev,
                  P_B_Narration: e.target.value,
                }))
              }
              renderValue={(selected) =>
                selected
                  ? reasonAttributes?.VendorDis?.find((x) => x.UID === selected)
                      ?.Name1
                  : "Select Reason"
              }
            >
              {reasonAttributes?.VendorDis?.map((opt) => (
                <MenuItem className="menuSm" key={opt.UID} value={opt.UID}>
                  {opt.Name1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/* Action Buttons */}
        <Grid
          item
          xs={12}
          sm={7}
          md={6}
          lg={5.8}
          display="flex"
          justifyContent="flex-end"
          alignItems="flex-end"
        >
          {/* Right: Buttons Group */}
          <Box display="flex" gap={0.3} flexWrap={"wrap"}>
            <Button
              size="small"
              variant="contained"
              onClick={fNewHead}
              disabled={transObj?.A_Status === "POST"}
            >
              New
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={() => fSave(false, "Saved")}
              disabled={transObj?.A_Status === "POST"}
            >
              Save
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={() => {
                confirmAlert({
                  title: "Approval Confirmation",
                  message: "Are you want to Approve?",
                  buttons: [
                    {
                      className: "alertBtn",
                      label: "Yes",

                      onClick: () => {
                        fSave(true, "Approved");
                      },
                    },
                    {
                      className: "alertBtn",
                      label: "No",
                      onClick: () => "",
                    },
                  ],
                });
              }}
              disabled={transObj?.A_Status === "POST"}
            >
              Approve
            </Button>
            {HeadObject?.Head?.A_Status_CM?.toUpperCase() === "REJECT" &&
              HeadObject?.Head?.A_Status?.toUpperCase() !== "ENTER" && (
                <Button
                  size="small"
                  variant="contained"
                  color="error"
                  onClick={() => {
                    confirmAlert({
                      title: "Reverse Confirmation",
                      message: "Are you sure you want to Reverse?",
                      buttons: [
                        {
                          className: "alertBtn",
                          label: "Yes",
                          onClick: () => {
                            reverseSave();
                          },
                        },
                        {
                          className: "alertBtn",
                          label: "No",
                          onClick: () => "",
                        },
                      ],
                    });
                  }}
                >
                  Reverse
                </Button>
              )}
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                if (!transObj.VendorName || !transObj.VendorCd) {
                  fAlertToast("FAILED", "Vendor should not be empty");
                  return;
                }
                setOpen(true);
              }}
              disabled={transObj?.A_Status === "POST"}
            >
              Master Data
            </Button>
            <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" onClick={handlePrint} size="small">
                <PrintOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
      {/* Data Grid Section */}
      <Box
        mt={1}
        sx={{
          height: { xs: "30vh", sm: "42vh", md: "59vh", lg: "60vh" },
        }}
      >
        <DataGridPro
          apiRef={apiRef}
          rowHeight={30}
          headerHeight={40}
          hideFooter
          rows={DetailData}
          getRowId={(v) => v.B_Srno}
          columns={[
            {
              field: "RowId",
              headerName: "Sr No",
              width: 50,
              align: "center",
              type: "number",
            },
            {
              field: "delete",
              headerName: "Action",
              width: 60,
              align: "center",
              hide:
                HeadObject?.Head?.A_Status?.toUpperCase() === "ENTER"
                  ? false
                  : true,
              renderCell: (params) => (
                <DeleteIcon
                  style={{
                    cursor:
                      transObj?.A_Status === "POST" ? "not-allowed" : "pointer",
                    color: transObj?.A_Status === "POST" ? "gray" : "red",
                  }}
                  onClick={() => {
                    if (transObj?.A_Status !== "POST") {
                      confirmAlert({
                        title: "Delete",
                        message: `Are you sure you want to delete this item ? ${params.row.ItemName}`,
                        buttons: [
                          {
                            label: "Yes",
                            onClick: () => handleDelete(params.row),
                          },
                          { label: "No" },
                        ],
                      });
                    }
                  }}
                />
              ),
            },
            {
              field: "B_Itemcd",
              headerName: "Item Code",
              width: 100,
              align: "center",
            },
            {
              field: "ItemName",
              headerName: "Item Name",
              minWidth: 160,
              flex: 1,
            },
            {
              field: "B_LocationcsvName",
              headerName: "Location",
              minWidth: 160,
              flex: 1,
            },
            {
              field: "B_Barcode",
              headerName: "Barcode",
              width: 120,
              align: "center",
            },

            { field: "UnitName", headerName: "Unit Name", width: 100 },
            {
              field: "Old_DisContinued",
              headerName: "Old",
              width: 40,
              align: "center",
              cellClassName: (params) =>
                params.row.Old_DisContinued !== params.row.New_DisContinued
                  ? "cell-old"
                  : "",
            },
            {
              field: "New_DisContinued",
              headerName: "New",
              width: 40,
              align: "center",
              cellClassName: (params) =>
                params.row.Old_DisContinued !== params.row.New_DisContinued
                  ? "cell-new"
                  : "",
            },
            {
              field: "B_NarrationName",
              headerName: "Reason",
              width: 140,
            },
            {
              field: "B_RejectDetailName",
              headerName: "Reject Type",
              width: 140,
            },
            {
              field: "P_B_RejectNarration",
              headerName: "Reject Narration ",
              width: 120,
            },
          ]}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          columnGroupingModel={columnGroupingModel}
          experimentalFeatures={{ columnGrouping: true }}
          onRowClick={(params) => handleRowClick(params.row)}
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              fontSize: "11px",
            },
            "& .MuiDataGrid-columnHeaderTitleContainer": {
              justifyContent: "center",
            },
          }}
        />
      </Box>
      {/* Master Data Modal */}
      <CycleCustomModal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        vMediaQuery={vMediaQuery}
        xMediaQuery={vMediaQuery}
        title={`Vendor Item Search -`}
        xVendor={`VendorName : ${transObj.VendorCd} - ${transObj.VendorName}`}
        children={
          <FilterModal
            vMediaQuery={vMediaQuery}
            xMediaQuery={vMediaQuery}
            fLoadDetail={fLoadDetail}
            handleClose={() => setOpen(false)}
          />
        }
      />
    </>
  );
};

export default VendorDiscontinueChangeRequestDetail;
